import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm';
import '../styles/Home.css';
import { ArrowRight, Code, Smartphone, TrendingUp, Palette, Bot, CheckCircle2 } from 'lucide-react';

const Home = () => {
  const [scrollY, setScrollY] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);

  const heroSlides = [
  "https://media.istockphoto.com/id/2212360504/photo/holographic-ui-ux-display-icons-of-ux-ui-designer-creative-planning-data-visualization-web.webp?a=1&b=1&s=612x612&w=0&k=20&c=tglFI9NeJVQNtibp78qcgjGBPkX43btcoxkLc1RN2_o=",
  "https://media.istockphoto.com/id/2210688897/photo/ux-ui-design-web-and-application-user-design-concepts-web-design-application-design-user.jpg?s=612x612&w=0&k=20&c=xGqukPJMP8lexSPr9mFW9_mZXgksPNd2p9MGBY5UjHw=",
  "https://media.istockphoto.com/id/2217534038/photo/vibrant-app-and-software-icons.jpg?s=612x612&w=0&k=20&c=xuDo0-GPulbLODXELHlmi61lSegWaH7K1Pg9c9elZRs=",
  "https://media.istockphoto.com/id/1304835109/photo/anonymous-person-typing-on-laptop-with-web-design-program-displayed-on-screen-ui-ux-website.jpg?s=612x612&w=0&k=20&c=kRKOnu8pDpHyzBUg3TiMlXIVT_XHCNIEsopzDg98vic=",
  "https://media.istockphoto.com/id/165817153/photo/seo-diagram.jpg?s=612x612&w=0&k=20&c=wzL6fFYnLpBFrWvRd8Nyfb9qZJMDa1JC3A13wAl6aNc=",
  "https://media.istockphoto.com/id/2244276959/photo/ai-concepts-for-developers-who-are-integrating-ai-into-their-applications-to-enable-users-to.jpg?s=612x612&w=0&k=20&c=FJd8kGq9h4dhFKbLJ9iGV1-B_8oFhqeveqfpN5dbXbM=",
  "https://media.istockphoto.com/id/844488274/photo/website-front-end-designer-reviewing-wireframe-layout-mockup-ar-screen.jpg?s=612x612&w=0&k=20&c=V8pvSN_OrP0H48TKaaD55rYm408L_YiNvf6-PHROb0Q="
];


  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide(prev => (prev + 1) % heroSlides.length);
    }, 3500);
    return () => clearInterval(timer);
  }, [heroSlides.length]);

  const services = [
    {
      icon: <Smartphone size={32} />,
      title: 'App Development',
      description: 'Native & cross-platform mobile apps with clean architecture and fast delivery.'
    },
    {
      icon: <Code size={32} />,
      title: 'Web Development',
      description: 'Scalable web applications built with modern frameworks and best practices.'
    },
    {
      icon: <TrendingUp size={32} />,
      title: 'SEO & Growth',
      description: 'Data-driven SEO strategies that increase organic traffic and conversions.'
    }
  ];

  const projects = [
   
    {
      id: 'townsendbarandgrill',
      title: 'Townsend Bar & Grill',
      tagline: 'Local bar & grill website revamp',
      category: 'Web App',
      image: 'https://townsendbarandgrill.com/wp-content/uploads/2025/04/welcome-to-towns-end-bar-and-grill.jpg',
      website: 'https://townsendbarandgrill.com/',
      tags: ['React', 'Tailwind', 'Dining'],
      results: 'Venue visibility +50%'
    },
    
    {
      id: 'scissorsscotch',
      title: 'Scissors & Scotch',
      tagline: 'Barbershop + lounge website',
      category: 'Web App',
      image: 'https://scissorsscotch.com/static/ss-assets/front/ss-design/assets/instagram/ig1.jpg',
      website: 'https://scissorsscotch.com/home',
      tags: ['React', 'Booking', 'Lifestyle'],
      results: 'Online appointments +35%'
    },
    
   
    
    {
      id: 'modocmedicalcenter',
      title: 'Modoc Medical Center',
      tagline: 'Medical centre web platform',
      category: 'Web App',
      image: 'https://modocmedicalcenter.org/wp-content/uploads/2025/04/Canby-Front.jpg',
      website: 'https://modocmedicalcenter.org/',
      tags: ['React', 'HealthTech', 'Accessibility'],
      results: 'Patient calls +30%'
    }
  ];

  const process = [
    { step: '01', title: 'Discover', description: 'Understanding your vision, goals, and user needs' },
    { step: '02', title: 'Prototype', description: 'Rapid prototyping and user testing for validation' },
    { step: '03', title: 'Build', description: 'Agile development with continuous delivery' },
    { step: '04', title: 'Grow', description: 'Launch, measure, and optimize for growth' }
  ];

  return (
    <div className="home" data-testid="home-page">
      <Navbar />

      {/* Hero Section with Image Slider Added */}
      <section className="hero" data-testid="hero-section">
        <div className="hero-background" style={{ transform: `translateY(${scrollY * 0.5}px)` }}>
          <div className="hero-grid"></div>
        </div>
        <div className="container hero-content">
          <div className="hero-text fade-in-up">
            <h1 className="hero-title" data-testid="hero-title">
              We build apps & websites that <span className="gradient-text">scale</span>
            </h1>
            <p className="hero-subtitle" data-testid="hero-subtitle">
              Product-minded engineering, pixel-perfect design, measurable growth.
            </p>
            <div className="hero-buttons">
              <a href="#contact" className="btn btn-primary btn-large" data-testid="cta-consultation">
                Get a free consultation
                <ArrowRight size={20} />
              </a>
              <Link to="/work" className="btn btn-secondary btn-large" data-testid="cta-see-work">
                See our work
              </Link>
            </div>
          </div>

          {/* Image Slider */}
          <div className="hero-image fade-in slider-wrapper" style={{ position: "relative", overflow: "hidden" }}>
            <img
              src={heroSlides[currentSlide]}
              alt="slide"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "16px",
                transition: "opacity 0.6s"
              }}
            />
          </div>
        </div>
      </section>

      {/* SEO / Expertise Section NEW */}
      <section className="seo-expertise" style={{ padding: "80px 0" }}>
        <div className="container text-center">
          <h2 className="section-title">Rank Higher & Grow Faster</h2>
          <p className="section-subtitle">Boost visibility, conversions & brand trust</p>
          <div className="expertise-tags">
            <span className="tag">SEO Optimization</span>
            <span className="tag">Google Ranking</span>
            <span className="tag">Technical SEO</span>
            <span className="tag">Performance Boost</span>
            <span className="tag">Digital Strategy</span>
          </div>
        </div>
      </section>

      {/* Upwork Badge Section NEW */}
      <section className="upwork-badge-section" style={{ padding: "60px 0" }}>
        <div className="container">
          <a href="https://upwork.com/freelancers/~01d905a37588aa03a0" target="_blank" rel="noopener noreferrer" className="upwork-card">
            <h3 className="upwork-title">Hire us on Upwork</h3>
            <div className="rating-stars">
              {[...Array(5)].map((_, i) => (
                <svg key={i} width="22" height="22" fill="#14a800">
                  <polygon points="12,2 15,9 22,9 17,14 19,21 12,17 5,21 7,14 2,9 9,9" />
                </svg>
              ))}
            </div>
            <strong className="rating-value">Top Rated 5.0 ⭐</strong>
          </a>
        </div>
      </section>

      {/* Services Snapshot */}
      <section className="services-snapshot" data-testid="services-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">What We Do</h2>
            <p className="section-subtitle">End-to-end digital product development</p>
          </div>
          <div className="services-grid">
            {services.map((service, index) => (
              <div className="service-card card" key={index} data-testid={`service-card-${index}`}>
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
          <div className="text-center" style={{ marginTop: '48px' }}>
            <Link to="/services" className="btn btn-primary" data-testid="view-all-services">
              View all services
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      {/* How We Work */}
      <section className="process-section" data-testid="process-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">How We Work</h2>
            <p className="section-subtitle">Our proven 4-step process for delivering exceptional products</p>
          </div>
          <div className="process-grid">
            {process.map((item, index) => (
              <div className="process-card" key={index} data-testid={`process-card-${index}`}>
                <div className="process-step">{item.step}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Projects */}
      <section className="featured-projects" data-testid="featured-projects-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Featured Work</h2>
            <p className="section-subtitle">Products we've built and shipped</p>
          </div>
          <div className="projects-grid">
            {projects.map((project, index) => (
              <Link to={`/work/${project.id}`} className="project-card" key={index} data-testid={`project-card-${index}`}>
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                  <div className="project-overlay">
                    <span className="view-case-study">View Case Study <ArrowRight size={16} /></span>
                  </div>
                </div>
                <div className="project-info">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="project-tags">
                    {project.tags.map((tag, i) => (
                      <span className="tag" key={i}>{tag}</span>
                    ))}
                  </div>
                </div>
              </Link>
            ))}
          </div>
          <div className="text-center" style={{ marginTop: '48px' }}>
            <Link to="/work" className="btn btn-primary" data-testid="view-all-work">
              View all projects
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-us" data-testid="why-choose-us-section">
        <div className="container">
          <div className="why-content">
            <div className="why-text">
              <h2 className="section-title">Why Choose BigSoftTech?</h2>
              <div className="why-points">
                <div className="why-point">
                  <CheckCircle2 size={24} className="check-icon" />
                  <div>
                    <h4>Product-First Approach</h4>
                    <p>We don't just code—we build products that solve real problems</p>
                  </div>
                </div>
                <div className="why-point">
                  <CheckCircle2 size={24} className="check-icon" />
                  <div>
                    <h4>Fast Delivery</h4>
                    <p>MVP in 8-12 weeks with agile sprints and continuous deployment</p>
                  </div>
                </div>
                <div className="why-point">
                  <CheckCircle2 size={24} className="check-icon" />
                  <div>
                    <h4>Measurable Results</h4>
                    <p>Analytics-driven development with clear KPIs and growth metrics</p>
                  </div>
                </div>
                <div className="why-point">
                  <CheckCircle2 size={24} className="check-icon" />
                  <div>
                    <h4>Ongoing Support</h4>
                    <p>Post-launch optimization and scaling as your business grows</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="why-image">
              <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800" alt="Team collaboration" />
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section" id="contact" data-testid="contact-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Let's Build Something Great</h2>
            <p className="section-subtitle">Get a free 30-minute product consultation</p>
          </div>
          <ContactForm />
        </div>
      </section>

      
    </div>
  );
};

export default Home;
